module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shape-input"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "title": _vm.fileName
    },
    on: {
      "click": function($event) {
        _vm.selectFile()
      }
    }
  }, [_vm._m(0, false, false), _c('input', {
    ref: "inputFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "inputFile",
      "type": "file",
      "accept": ".zip, .shp, .SHP"
    },
    on: {
      "change": _vm.onChange
    }
  }), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": _vm.fileName
    }
  })]), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.file),
      expression: "!file"
    }],
    staticClass: "text-muted"
  }, [_vm._v("Shapes de até " + _vm._s(_vm.maxFileSize) + " MB nos formatos shp ou zip.")]), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.file && !_vm.loading && !_vm.error),
      expression: "file && !loading && !error"
    }],
    staticClass: "text-success"
  }, [_vm._v("Shape carregado com sucesso.")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-striped progress-bar-animated",
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "75",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v("Processando arquivo")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-folder-open"
  }), _vm._v(" Selecionar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d81aaa6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ShapeInput.vue
// module id = 466
// module chunks = 1